
import { mapMutations, mapState, mapGetters } from 'vuex';
import { events } from '@/lib/clevertap';
import { mdiCartOutline, mdiPlus, mdiMinus } from '@mdi/js';
import { SHOP } from '@/lib/constants';
import shop_mixin from '@/mixins/shop_mixin';
export default {
  mixins: [shop_mixin],
  props: {
    selectedProduct: Object,
    preview: {
      type: Boolean,
      default: false
    },
    variantId: Number
  },
  data() {
    return {
      cart: [],
      product: {},
      variant: {},
      tabs: [
        { title: 'Product Description', value: 'description' },
        { title: 'Cancellation Policy', value: 'cancelation_policy' },
        { title: 'Refund Policy', value: 'refund_policy' }
      ],
      selectedTab: 'description',
      selection: {},
      unAvailable: false,
      bannerImg: '',
      qty: 1,
      country: {
        name: this.$auth?.user?.shopCountry?.currency ?? 'INR',
        symbol: this.$auth?.user?.shopCountry?.currency_symbol ?? '₹'
      },
      bannerImgIdx: 0,
      icons: {
        mdiCartOutline,
        mdiPlus,
        mdiMinus
      },
      SHOP,
      variantLinks: [],
      showAlreadyPurchasedMessage: false
    };
  },
  computed: {
    ...mapState('global', ['unregisteredUserId']),
    isShowQuantityAndCartOption() {
      return (
        this.product.type !== this.SHOP.PRODUCT_TYPE.SUBSCRIPTION &&
        this.product.type !== this.SHOP.PRODUCT_TYPE.THIRD_PARTY_COUPONS &&
        this.product.type !==
        this.SHOP.PRODUCT_TYPE.THIRD_PARTY_COUPON_WITH_SUBSCRIPTION
      );
    }
  },
  methods: {
    ...mapMutations('general', ['setOffer', 'setBrand', 'setCategory']),
    async addToCart(buyNow = false) {
      const { product, variant, qty, selection } = this;
      const id = new Date().getTime();

      // const requestData = {
      //   controller: 'addItem',
      //   childId: this.getChild.id,
      //   id,
      //   productId: product.id,
      //   variantId: variant.id,
      //   quantity: qty
      // };
      // if (buyNow) requestData.buyNow = true;
      // await this.$api.cart.create(requestData);

      const item = {
        id,
        productId: product.id,
        variantId: variant.id,
        quantity: qty
      };
      if (buyNow) item.buyNow = true;
      await this.addItemToCart(item);

      this.cart = await this.getCart();

      // await this.getCart();

      this.showAlert('Item added to cart!', 'success');

      this.$emit('trackVariantSelection', {
        event: buyNow ? events.BUY_NOW : events.ADDED_TO_CART,
        payload: {
          productName: variant.name,
          productPurchasePrice: variant.offer_price,
          productTotalPrice: variant.actual_price,
          priceInPoints: variant.points_required,
          quantity: qty,
          ...selection
        }
      });

      if (buyNow) {
        this.$router.push('/shop/checkout');
      }
    },
    addQuantity() {
      const { unlimited_supply, qty: availableQty } = this.variant;
      if (unlimited_supply === 0 && availableQty <= this.qty) {
        this.$notifier.showMessage({
          content: 'Maximun quantity is reached!',
          color: 'error'
        });
        return;
      }

      this.qty += 1;
    },
    async onChangeCategory(key, value) {
      const variations = this.product.variations.map(el => {
        return { ...el, ...JSON.parse(el.extraAttr) };
      });

      this.selection[key] = value;
      this.selection = { ...this.selection };

      const variant = variations.find(va => {
        return Object.keys(this.selection).every(k => {
          return this.selection[k] === va[k];
        });
      });

      this.unAvailable = this.isProductUnavailable(variant);
      if (!this.unAvailable) await this.setVariant(variant);

      this.qty = 1;
    },
    setVariantLinks() {
      let availableVariants = this.product.variations.map(el => {
        return { ...el, ...JSON.parse(el.extraAttr) };
      });
      let variantsForCategory;
      this.product.variationCategories.forEach((cat, index) => {
        if (index === this.product.variationCategories.length - 1) {
          variantsForCategory = cat;
        } else {
          availableVariants = availableVariants.filter(
            va => `${va[cat]}` === `${this.selection[cat]}`
          );
        }
      });

      this.variantLinks = [];
      this.product.variationCategoryValues[variantsForCategory]?.forEach(
        catValues => {
          const matchingVariant = availableVariants.find(
            el => el[variantsForCategory] === catValues['value']
          );
          let link;
          if (matchingVariant)
            link = `/shop/products/${
              matchingVariant.product_url ??
              `${this.product.id}?variantId=${matchingVariant.id}`
            }`;
          else link = `/shop/products/${this.product.id}`;
          this.variantLinks.push(link);
        }
      );
    },
    async setVariant(variant) {
      if (!variant) return;

      const extraAttr = JSON.parse(variant.extraAttr);

      const priceAvailableForCountries = Object.keys(extraAttr.countryPricing);
      const priceForAdmin =
        this.$auth?.user?.shopCountry?.id ??
        priceAvailableForCountries.includes('81')
          ? 81
          : priceAvailableForCountries[0];
      const prices =
        extraAttr.countryPricing[
        this.$auth?.user?.shopCountry?.id ?? priceForAdmin
          ];

      this.variant = {
        ...variant,
        ...extraAttr,
        offer_price: prices?.offer_price,
        actual_price: prices?.actual_price
      };

      this.bannerImg = this.variant.defaultImg;

      this.product.variationCategories.forEach(key => {
        this.selection[key] = this.variant[key];
      });
      this.setVariantLinks();

      if (this.$auth?.loggedIn && (this.product.type === this.SHOP.PRODUCT_TYPE.THIRD_PARTY_COUPONS ||
        this.product.type === this.SHOP.PRODUCT_TYPE.THIRD_PARTY_COUPON_WITH_SUBSCRIPTION)) {
        if (extraAttr.oneTimePurchaseOnly && extraAttr.thirdPartyOffer) {
          const resp = await this.$api.shop.find({
            items: 'isAlreadyPurchasedThirdPartyProduct',
            childId: this.getChild?.id,
            offerId: extraAttr.thirdPartyOffer
          });
          this.showAlreadyPurchasedMessage = resp?.alreadyPurchased;
        } else {
          this.showAlreadyPurchasedMessage = false;
        }
      }

      this.$emit('trackVariantSelection', {
        event: events.PRODUCT_VIEWED,
        payload: {
          productName: this.variant.name,
          productPurchasePrice: this.variant.offer_price,
          productTotalPrice: this.variant.actual_price,
          priceInPoints: this.variant.points_required,
          productAvailability:
            this.variant.unlimited_supply === 1 || this.variant.qty > 0
        }
      });

      return this.variant;
    },
    checkAvailability() {
      const variations = this.product.variations.map(el =>
        JSON.parse(el.extraAttr)
      );

      this.product.variationCategoryValues =
        this.product.variationCategories.reduce((acc, key) => {
          acc[key] = this.product.variationCategoryValues[key].map(value => {
            const status = variations.some(va => va[key] === value);

            if (status) return { value, enable: true };
            return { value, enable: false };
          });

          return acc;
        }, {});
    },
    setBannerImage(idx) {
      this.bannerImg = this.variant.images[idx];
    },
    showAlert(content, color = 'error') {
      this.$notifier.showMessage({ content, color });
    },
    checkCartItems(setDefault = true) {
      const items = this.cart.filter(c => c.product_id === this.product.id);
      if (items.length) {
        let item = items.find(i => i.variant_id === this.variant.id);
        if (!item && setDefault) item = items[0];

        if (!item) {
          this.qty = 1;
          return;
        }

        const { variant_id, qty } = item;
        const variant = this.product.variations.find(v => v.id === variant_id);
        if (variant) {
          this.setVariant(variant);
          this.qty = qty;
        }
      }
    },
    // async getCart() {
    //   if (this.$auth.user && this.$auth.user.role !== 'Parent') {
    //     this.cart = [];
    //     return;
    //   }
    //   const resp = await this.$api.cart.get(this.getChild.id, {
    //     country_id: this.$auth?.user?.shopCountry?.id ?? 81
    //   });
    //   this.cart = resp.items ? resp.items : [];
    // },
    isProductUnavailable(variant) {
      if (!variant) {
        return true;
      }
      if (
        this.product.type === this.SHOP.PRODUCT_TYPE.PARTNER_BRAND ||
        this.product.type === this.SHOP.PRODUCT_TYPE.SUBSCRIPTION
      ) {
        if (variant.unlimited_supply === 0 && variant.qty === 0) return true;
      } else if (
        this.product.type === this.SHOP.PRODUCT_TYPE.THIRD_PARTY_COUPONS ||
        this.product.type ===
        this.SHOP.PRODUCT_TYPE.THIRD_PARTY_COUPON_WITH_SUBSCRIPTION
      ) {
        if (variant.availableCoupons === 0) return true;
      }
      return false;
    },
    async trackPopularity(variantId) {
      if (!this.$auth?.loggedIn) return;
      await this.$api.shop.find({
          items: 'trackPopularity',
          variantId: variantId,
          parentId: this.$auth?.user?.id,
          childId: this.getChild?.id,
          userId: this.unregisteredUserId
        });
    }
  },
  async fetch() {
    // await this.getCart();
    this.cart = await this.getCart();

    this.product = {
      ...this.selectedProduct,
      ...JSON.parse(this.selectedProduct.extraAttr)
    };

    const { variation, variationCategories } = this.product;
    this.product.variationCategories = variationCategories.map(c =>
      c.toLowerCase()
    );

    let requestedVariant = variation;
    if (this.variantId) {
      requestedVariant = this.product.variations.find(
        el => el.id === this.variantId
      );
      if (!requestedVariant) requestedVariant = variation;
    }

    this.unAvailable = this.isProductUnavailable(requestedVariant);
    await this.setVariant(requestedVariant);
    this.checkAvailability();
  },
  destoryed() {
    this.setOffer(null);
    this.setBrand(null);
    this.setCategory(null);
  }
};
